module.exports = "/_next/static/images/engineeringEnergy-1142510d2f540986a87e3e54bf5899fa.webp";